import CloseIcon from '@mui/icons-material/Close'
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined'
import PropTypes from 'prop-types'
import { useState } from 'react'

import { StatusInfo } from '@components/status-info'
import { UserForm } from '@components/user'
import { AdasBox, AdasButton, AdasCard, AdasDivider, AdasTypography } from '@components/wrapper-components'
import { getRole, phoneNumberFormat } from '../../../utils/utils'
import theme from 'theme/theme'
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const UserInfo = (props) => {
  const { userInfo, closeDrawer, updateClientListHandler, global = false, userCenters = [], allowDelete = false } = props
  const [updatedUserInfo, setUpdatedUserInfo] = useState(userInfo)
  const [isUserEdit, setIsUserEdit] = useState(false)
  const labelStyle = {
    margin: '8px 0px',
    fontWeight: '600'
  }
  const onSaveClientSuccessHandler = (props) => {
    setUpdatedUserInfo(props)
    updateClientListHandler()
    setIsUserEdit(false)
    closeDrawer()
  }

  const onDeleteClientSuccessHandler = () => {
    updateClientListHandler()
    closeDrawer()
  }

  const RecordInformation = ({ lastModified }) => {
    const formattedDate = lastModified ? new Date(lastModified).toLocaleDateString() : ''
    const formattedTime = lastModified
      ? new Date(lastModified).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
      : ''

    return (
      <AdasBox>
        <AdasTypography variant='overline' sx={{ color: '#6b7280', fontWeight: 600 }}>
          RECORD INFORMATION
        </AdasTypography>

        <AdasCard
          sx={{
            display: 'flex',
            padding: 1,
            borderRadius: 2,
            backgroundColor: '#fff',
            borderLeft: '4px solid #b7bec8'
          }}
        >
          <AccessTimeOutlinedIcon sx={{ fontSize: 20, color: '#6b7280', marginRight: '8px' }} />
          <AdasTypography variant='body2' sx={{ color: '#4b5563', fontStyle: 'italic' }}>
            <strong>Last Modified:</strong> {formattedDate} @ {formattedTime}
          </AdasTypography>
        </AdasCard>
      </AdasBox>
    )
  }

  return (
    <AdasBox>
      <AdasBox className='drawer-title-container'>
        <AdasTypography variant='h6'>User Info</AdasTypography>
        <AdasButton
          buttonType='iconButton'
          sx={{
            padding: '2px',
            cursor: 'pointer',
            color: theme.palette.info.main
          }}
          onClick={closeDrawer}
        >
          <CloseIcon fontSize='small' />
        </AdasButton>
      </AdasBox>
      {!isUserEdit ? (
        <AdasCard className='adas-card'>
          <span>
            <AdasTypography sx={{ fontWeight: '600', display: 'inline' }} variant='h6'>
              {updatedUserInfo.name}
            </AdasTypography>
            <StatusInfo
              color={updatedUserInfo.is_active ? 'primary' : 'default'}
              label={updatedUserInfo?.is_active ? 'Active' : 'Inactive'}
              sx={{ float: 'right' }}
            />
          </span>
          <AdasDivider sx={{ margin: '8px 0px' }} />
          <AdasTypography sx={labelStyle} variant='subtitle2'>
            Role
          </AdasTypography>
          <AdasTypography>{getRole(updatedUserInfo)}</AdasTypography>
          <AdasTypography sx={labelStyle} variant='subtitle2'>
            Email
          </AdasTypography>
          <AdasTypography>
            <a href={`mailto:${updatedUserInfo.email}`}>{updatedUserInfo.email}</a>
          </AdasTypography>
          <AdasTypography sx={labelStyle} variant='subtitle2'>
            Phone
          </AdasTypography>

          <AdasTypography>
            <a href={`tel:${updatedUserInfo.phone}`}>{phoneNumberFormat(updatedUserInfo.phone)}</a>
          </AdasTypography>
          <AdasDivider sx={{ margin: '8px 0px' }} />
          <RecordInformation lastModified={updatedUserInfo.updated_at ? updatedUserInfo.updated_at : updatedUserInfo.created_at} />
          {userCenters.length > 0 && (
            <AdasBox>
              <AdasTypography sx={labelStyle} variant='subtitle2'>
                Center(s)
              </AdasTypography>
              <ul>
                {userCenters.map((center) => (
                  <li key={center.id}>{center.name}</li>
                ))}
              </ul>
            </AdasBox>
          )}
          <AdasBox sx={{ textAlign: 'end' }}>
            <AdasButton
              startIcon={<ModeEditOutlineOutlinedIcon />}
              key='2'
              aria-label='Cancel'
              color='primary'
              onClick={() => setIsUserEdit(true)}
            >
              Edit
            </AdasButton>
          </AdasBox>
        </AdasCard>
      ) : (
        <UserForm
          allowDelete={allowDelete}
          isAddUser={false}
          isEdit={isUserEdit}
          userData={userInfo}
          close={() => setIsUserEdit(false)}
          onSaveSuccess={onSaveClientSuccessHandler}
          onDeleteSuccess={onDeleteClientSuccessHandler}
          global={global}
        />
      )}
    </AdasBox>
  )
}

UserInfo.propTypes = {
  userInfo: PropTypes.object,
  closeDrawer: PropTypes.func.isRequired,
  updateClientListHandler: PropTypes.func.isRequired,
  global: PropTypes.bool,
  userCenters: PropTypes.array,
  allowDelete: PropTypes.bool
}
